import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import Lottie from "lottie-react";
import sadFaceAnimation from "@arelia-assets/lottie-animations/sad-face.json"

export default function NoSubscription() {
  return <Box sx={styles.animation}>
    <Typography variant="subtitle1">Not subscribed yet.</Typography>
    <Lottie
      animationData={sadFaceAnimation}
      style={{ height: 200 }}
    />
  </Box>
}

const styles = {
  animation: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column"
  }
}